// Auto-generated file created by svgr-cli source svg-template.js
// Do not edit directly
import * as React from 'react'
import type { SVGProps } from 'react'
import { Ref, forwardRef, memo } from 'react'
const SvgIconNetwork = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg xmlns='http://www.w3.org/2000/svg' width={props.width || 16} height={props.height || 16} fill='none' viewBox='0 0 16 16' ref={ref} {...props}>
        <path
            fill='currentcolor'
            d='M6 1.333c-.662 0-1.2.532-1.2 1.188v2.375c0 .655.538 1.187 1.2 1.187h1.2v1H1.467c-.443 0-.8.354-.8.792s.357.792.8.792H3.2v1.25H2c-.662 0-1.2.532-1.2 1.187v2.375c0 .656.538 1.188 1.2 1.188h4c.663 0 1.2-.532 1.2-1.188v-2.375c0-.655-.537-1.187-1.2-1.187H4.8v-1.25h6.4v1.25H10c-.662 0-1.2.532-1.2 1.187v2.375c0 .656.538 1.188 1.2 1.188h4c.663 0 1.2-.532 1.2-1.188v-2.375c0-.655-.537-1.187-1.2-1.187h-1.2v-1.25h1.734c.442 0 .8-.354.8-.792a.795.795 0 0 0-.8-.792H8.8v-1H10c.663 0 1.2-.532 1.2-1.187V2.52c0-.656-.537-1.188-1.2-1.188z'
        />
    </svg>
)
const ForwardRef = forwardRef(SvgIconNetwork)
const Memo = memo(ForwardRef)
export default Memo
